/**
 * @Author : zhouqinze
 * @Date : 2019-12-30
 * @Version : 1.0
 * @Content : comit官网
 **/
<template>
  <div id="app">
    <Header />
    <!-- <Home /> -->
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
// import Home from './pages/Home'
import Footer from './components/Footer.vue'
export default {
  name: 'app',
  components: {
    Header,
    // Home,
    Footer
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
